export const DEFAULT_METRICS_RANGE_DAYS = 30;

export function getDefaultMetricsDateRange(): [
  Temporal.PlainDate,
  Temporal.PlainDate,
] {
  const end = Temporal.Now.plainDateISO();
  const start = end.subtract({ days: DEFAULT_METRICS_RANGE_DAYS - 1 });
  return [start, end];
}

export function safeParseMetricsDate(
  value: string | null,
): Temporal.PlainDate | undefined {
  if (!value) {
    return undefined;
  }
  try {
    return Temporal.PlainDate.from(value);
  } catch {
    return undefined;
  }
}
